<template>
    <div class="carddesign card h-100">
        <div class="card-header" v-html="$strings('main.tiles.Timetable.title')"></div>
        <div class="card-body">
            <p class="card-text" v-html="$strings('main.tiles.Timetable.description')"></p>
            <router-link class="btn btn-primary"
                :to="{ name: $strings('main.tiles.Timetable.link') }">{{ $strings('main.tiles.Timetable.linkTitle') }}&nbsp;<i class="bi bi-arrow-right"></i></router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TimetableTile',
        methods: {}
    };
</script>

<style scoped>
</style>
